import React from "react";
import { Close } from "ceicons";

import "./pillWithButton.scss";

export default function PillWithButton(props) {
  const { pill, onRemove } = props;
  return (
    <div className="pillWithButtons">
      <p className="pillWithButtons_title">{pill}</p>
      {onRemove && (
        <div className="icon-container" onClick={onRemove}>
          <Close />
        </div>
      )}
    </div>
  );
}
